<template>
	<div id="app">
		<transition name="el-fade-in-linear" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>
<script>
	import axios from 'axios'
	import { config } from '@config/network.js'

	export default {
		name: 'app',
		mounted() {
			this.getBuildTime()
		},
		methods: {
			getBuildTime() {
				const timestamp = Date.parse(new Date()) / 1000
				axios.get(config.API + 'warehouse_apply_front/build-time.log?v=' + timestamp, { params: {} }).then(res => {
					const build_time = localStorage.getItem('build-time') || ''
					if (build_time && build_time != res.data) {
						this.$alert('系统已经更新，请刷新页面', '提示', {
							confirmButtonText: '立即刷新',
							showClose: false,
							callback: action => {
								location.reload()
							}
						});
					} else {
						setTimeout(() => {
							this.getBuildTime()
						}, 10000);
					}
					localStorage.setItem('build-time', res.data)
				})
			}
		}
	}
</script>
<style lang="scss">
body {
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
}
#app {
	width: 100%;
	height: 100%;
	min-width: 1000px;
}
.el-submenu__title{
	min-width: 200px;
}
</style>


// WEBPACK FOOTER //
// App.vue?7ae13309